import { Directive, HostBinding, Injector, Input, OnInit, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ChannelName } from '../../models/interfaces';
import { LoaderBusService } from '../../services/loader-bus/loader-bus.service';

/**
 * A directive that can be added to a Reactive form group to disable it while the state of a loader channel is true. By default this directive monitors
 * the `global` channel, but the channel can be set using the `channelName` input alongside this directive.
 */
@Directive({
    selector: '[ofLoaderTogglesClass]',
    standalone: false
})
export class LoaderTogglesClassDirective implements OnInit {
    /** An optional name for the loading channel that the host's class change in response to. Defaults to `global`.*/
    @Input() channelName: ChannelName;

    /** @ignore Signal derived from the loader channel. Initialized in ngOnInit once channelName input is available. */
    private _isLoading!: Signal<boolean>;

    /** @ignore */
    @HostBinding('class.loading--is-active') get addActive() { return this._isLoading?.() ?? false; }
    /** @ignore */
    @HostBinding('class.loading--is-inactive') get addInactive() { return !(this._isLoading?.() ?? false); }

    /** @ignore */
    constructor(private _loader: LoaderBusService, private _injector: Injector) {}

    /** @ignore */
    ngOnInit(): void {
        const channel = this.channelName || 'global';
        this._isLoading = toSignal(
            this._loader._globalChannels[channel].getStatus,
            { initialValue: false, injector: this._injector }
        );
    }
}
